// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'

const buttonClasses = 'btn btn-md hover-inverse margin-left-1 margin-right-1 heading-font'

const DiscardConfirmation = props => {
  const {
    closeModal,
    confirmAction,
    idRoot,
    message,
  } = props

  return (
    <div className={'path-details-footer-modal'}>
      <h3 className={'center-text uppercase padding-half'}>
        <span
          className={'text-blue-dark'}
          id={`${idRoot}-heading`}>
          {'Do you want to leave?'}
        </span>
        <span className={'alert-decoration'} />
      </h3>
      <p
        className={'padding-half center-text'}
        id={`${idRoot}-message`}>
        {message}
      </p>
      <div className={'display-flex justify-content-center padding-top-1'}>
        <button
          className={`bg-grey-blue ${buttonClasses}`}
          id={'discard-confirmation-modal-cancel'}
          onClick={closeModal}>
          {'Cancel'}
        </button>
        <button
          className={`bg-blue ${buttonClasses}`}
          id={'discard-confirmation-modal-discard'}
          onClick={confirmAction}>
          {'Confirm'}
        </button>
      </div>
    </div>
  )
}

DiscardConfirmation.propTypes = {
  closeModal: func.isRequired,
  confirmAction: func.isRequired,
  idRoot: string,
  message: string,
}

DiscardConfirmation.defaultProps = {
  idRoot: 'discard-confirmation',
  message: 'Are you sure you want to leave without Saving?',
}

export default DiscardConfirmation
